import { render, staticRenderFns } from "./BlackOverlay.vue?vue&type=template&id=75810864"
import script from "./BlackOverlay.vue?vue&type=script&lang=js"
export * from "./BlackOverlay.vue?vue&type=script&lang=js"
import style0 from "./BlackOverlay.vue?vue&type=style&index=0&id=75810864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports